module.exports = __webpack_public_path__ + "img/covid19new.6dc95853.svg";